module.exports = __webpack_public_path__ + "img/2.b07506ca.jpg";